import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Shared between `Button` and `ButtonLink`: renders the label, plus a trailing icon in an
 * `aria-hidden` wrapper span when one is supplied. Suppresses the icon while `loading` so it
 * doesn't render alongside `Button`'s spinner (`ButtonLink` has no loading state, so it always
 * passes `loading: false`).
 */
export const buttonContent = (label, icon, loading = false) => icon && !loading ? (_jsxs(_Fragment, { children: [label, _jsx("span", { "aria-hidden": "true", className: "ml-15 [&_svg]:h-2.75 [&_svg]:w-2.75", children: icon })] })) : (label);
